export default __webpack_public_path__ + "static/media/BerkshireHathaway.c65c1727.jpg";